/*
  Razz Aquatics - Card JS
  Handles qty +/- and add-to-cart for single-variant cards.
  Loaded once globally via theme.liquid.
*/
(function () {
  if (window.__razzCardInit) return;
  window.__razzCardInit = true;

  // ---- STOQ Notify Me ----
  function attachStoq() {
    document.querySelectorAll('[data-stoq-notify]:not([data-stoq-attached])').forEach(function (btn) {
      btn.dataset.stoqAttached = 'true';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (window._RestockRocket && window._RestockRocket.openModal) {
          try {
            window._RestockRocket.openModal(
              JSON.parse(btn.getAttribute('data-product')),
              btn.getAttribute('data-variant-id')
            );
          } catch (err) { console.warn('STOQ', err); }
        }
      });
    });
  }
  if (window._RestockRocket) { attachStoq(); }
  else { window.addEventListener('stoq:loaded', attachStoq); }
  setTimeout(attachStoq, 3000);

  // ---- Qty +/- buttons ----
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-razz-minus], [data-razz-plus]');
    if (!btn) return;
    var ctrl = btn.closest('.razz-pc__qty-ctrl');
    if (!ctrl) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var display = ctrl.querySelector('.razz-pc__qty-display');
    if (!display) return;
    var current = parseInt(display.textContent, 10) || 1;

    if (btn.hasAttribute('data-razz-minus')) {
      display.textContent = Math.max(1, current - 1);
    } else {
      var row = ctrl.closest('[data-razz-atc]');
      var max = row ? (parseInt(row.dataset.max, 10) || 999) : 999;
      if (max <= 0) max = 999;
      if (current + 1 > max) {
        display.style.color = '#E07000';
        setTimeout(function () { display.style.color = ''; }, 600);
        return;
      }
      display.textContent = current + 1;
    }
  }, true);

  // ---- Update cart drawer DOM ----
  function updateCartDrawer(sections, triggerBtn) {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;
    var parser = new DOMParser();

    if (sections['cart-drawer']) {
      var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
      var newCartDrawer = doc.querySelector('#CartDrawer');
      var oldCartDrawer = document.querySelector('#CartDrawer');
      if (newCartDrawer && oldCartDrawer) {
        oldCartDrawer.innerHTML = newCartDrawer.innerHTML;
      }
    }

    if (sections['cart-icon-bubble']) {
      var bubbleDoc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
      var newBubble = bubbleDoc.querySelector('.shopify-section');
      var oldBubble = document.getElementById('cart-icon-bubble');
      if (newBubble && oldBubble) oldBubble.innerHTML = newBubble.innerHTML;
    }

    cartDrawer.classList.remove('is-empty');
    var drawerInner = cartDrawer.querySelector('.drawer__inner');
    if (drawerInner) drawerInner.classList.remove('is-empty');

    var overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      var newOverlay = overlay.cloneNode(true);
      overlay.parentNode.replaceChild(newOverlay, overlay);
      newOverlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
    }

    if (typeof cartDrawer.setActiveElement === 'function') cartDrawer.setActiveElement(triggerBtn);

    // Re-initialise the delivery date picker after #CartDrawer innerHTML is
    // replaced. The DOM swap includes .drawer__footer (which contains
    // #RazzaDeliveryDate), but innerHTML does not execute <script> tags so
    // picker listeners are not attached automatically.
    if (window.razzaDeliveryDate) window.razzaDeliveryDate.init();

    // Refresh the shipping bar for the new cart state.
    if (window.razzaShippingBar) window.razzaShippingBar.refresh();

    // Sync discount pill after card ATC.
    // razz-card.js replaces #CartDrawer.innerHTML directly (bypassing
    // CartDrawer.renderContents), so it never ran the discount refresh
    // that renderContents now includes. The Liquid section render already
    // contains the correct pill HTML; razzaDiscount.refresh() fetches
    // /cart.js and calls renderTags(), which uses the v6 DOM-key check to
    // preserve the Liquid-rendered pill rather than clearing and rebuilding it.
    if (window.razzaDiscount) window.razzaDiscount.refresh();

    if (typeof cartDrawer.open === 'function') cartDrawer.open(triggerBtn);
  }

  // ---- Add to cart using FormData (most reliable for Shopify sections) ----
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-razz-add]');
    if (!btn) return;
    var row = btn.closest('[data-razz-atc]');
    if (!row) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var variantId = row.dataset.variantId;
    var display = row.querySelector('.razz-pc__qty-display');
    var qty = display ? (parseInt(display.textContent, 10) || 1) : 1;
    var label = btn.querySelector('.razz-atc-label');
    var spinner = btn.querySelector('.loading__spinner');

    btn.disabled = true;
    if (label) label.style.opacity = '0';
    if (spinner) spinner.classList.remove('hidden');

    // FormData is what Shopify expects for sections rendering
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', String(qty));
    formData.append('sections', 'cart-drawer,cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          throw new Error(response.description || response.message || 'Could not add to cart');
        }

        if (response.sections) {
          updateCartDrawer(response.sections, btn);
        }

        if (label) { label.textContent = 'Added!'; label.style.opacity = '1'; }
        if (spinner) spinner.classList.add('hidden');
        btn.disabled = false;
        setTimeout(function () {
          if (label) label.textContent = 'Add to Cart';
          if (display) display.textContent = '1';
        }, 1500);
      })
      .catch(function (err) {
        console.error('Razz ATC error:', err.message);
        if (label) { label.textContent = 'Error - try again'; label.style.opacity = '1'; }
        if (spinner) spinner.classList.add('hidden');
        btn.disabled = false;
        setTimeout(function () { if (label) label.textContent = 'Add to Cart'; }, 2000);
      });
  });

})();
